import Parse from 'parse';

export default async function setUserTrackingApi(
  eventId: string,
  email: string,
) {
  return Parse.Cloud.run('setUserTracking', { eventId: eventId, email: email });
}
